module.exports = __webpack_public_path__ + "img/Witnessing_Mobile.jpg";